var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTehnikIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.63,14.74C1.87,14.74,0,18.03,0,19.06c0,0.59,0,1.57,0,1.57h17c0,0,0-0.77,0-1.44C17,18.52,15.4,14.74,8.63,14.74z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1602 0.1602 0.9871 -1.1225 1.44)",
    cx: 8.37,
    cy: 7.68,
    rx: 4.32,
    ry: 4.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.96,8.66c-0.38-1.91-1.97-2.41-1.97-2.41l-0.07,2.82L19.96,9.1L19.94,6.3c0,0-0.63,0.15-1.21,0.72 c-0.58,0.57-0.93,1.66-0.7,2.85c0.28,1.47,1.67,2.05,1.67,2.05l-0.04,8.71l2.43,0l0.07-8.76c0,0,0.57-0.27,0.96-0.66 C23.53,10.83,24.17,9.7,23.96,8.66z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTehnikIcon);
export default __webpack_public_path__ + "static/media/tehnik_icon.b0724bf3.svg";
export { ForwardRef as ReactComponent };